/* Close multiselect single input when selecting value */
export const cancelDropdown = (className: string) => {
   const dropDownElement: any = document.querySelectorAll(
      `.${className} .dropdown-heading`,
   ) as any;
   if (dropDownElement.length === 0) return;
   dropDownElement[0].dispatchEvent(new MouseEvent('click', { bubbles: true }));
};
